export enum HubName {
  Chat = 'hubs/chat',
  Present = 'hubs/present',
  Noti = 'hub/notification',
  Dating = 'hubs/dating',
  ClanChat = 'hubs/clanchat',
}

export enum HubEvent {
  NewMessage = 'NewMessage',
  NewNotification = 'SendNotification',
  NewMessageDating = 'NewDatingMessage',
  NewClanMessage = 'NewClanMessage',
}
